import { useSelector } from "react-redux";
import { hasAllPermissions } from "../redux/selectors/authSelector";

const Can = ({ permissions = [], children, fallback = null }) => {
  const allowed = useSelector(hasAllPermissions(permissions));

  if (!allowed) return fallback;

  return children;
};

export default Can;
